// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"94":"9a8a1993882e9a289be3","197":"f374563cb2cdaa30ae12","236":"21edfd3c91ff356d27d5","387":"98417e470f31560d0788","436":"a611374e57e58186cd61"}[chunkId] + ".js";
};